export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  const row = [];
  for (let i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(Math.max(i - 3, 0), i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    const chuc = Math.floor(so / 10);
    const donvi = so % 10;
    if (chuc > 1) {
      chuoi = " " + chuSo[chuc] + " mươi";
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += " " + chuSo[donvi];
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    let chuoi = "";
    const tram = Math.floor(so / 100);
    const soDu = so % 100;
    if (daydu || tram > 0) {
      chuoi = " " + chuSo[tram] + " trăm";
      chuoi += docHangChuc(soDu, true);
    } else {
      chuoi = docHangChuc(soDu, false);
    }
    return chuoi;
  };

  const docSo = (so) => {
    let ketQua = "";
    const viTri = row.length - 1;
    for (let i = viTri; i >= 0; i -= 1) {
      const soNhom = parseInt(row[i], 10);
      if (soNhom > 0) {
        ketQua += `${docKhoi(soNhom, i !== viTri)} ${tien[i]}`;
      }
    }
    const normalized = ketQua.trim();
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  };

  return `${docSo(number)} đồng chẵn`;
};

const parseMoney = (value) => Number(String(value || "").replace(/\D/g, "")) || 0;
const fmt = (n) => new Intl.NumberFormat("vi-VN").format(Math.round(parseMoney(n)));

export const getPrintTemplate = ({ headerInfo, rows, totalBonus }) => {
  const rowsHtml = rows
    .map(
      (row, i) => `
      <tr>
        <td class="text-center">${i + 1}</td>
        <td class="text-left">${row.fullName || ""}</td>
        <td class="text-center">${row.rank || ""}</td>
        <td class="text-center">${row.bonusType || ""}</td>
        <td class="text-right">${fmt(row.amount)}</td>
        <td class="text-center">${row.signature || ""}</td>
        <td class="text-left">${row.note || ""}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Bảng Thanh Toán Tiền Thưởng</title>
      <style>
        @media print {
          @page { margin: 10mm; size: landscape; }
        }
        body {
          font-family: "Times New Roman", Times, serif;
          color: #000;
          padding: 20px;
          font-size: 12px;
        }
        .header-top { display: flex; justify-content: space-between; margin-bottom: 16px; }
        .title-box { text-align: center; margin: 16px 0; }
        .title-main { font-size: 18px; font-weight: bold; margin: 0; text-transform: uppercase; }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        th, td { border: 1px solid #000; padding: 4px; }
        th { text-align: center; font-weight: bold; vertical-align: middle; }
        .text-center { text-align: center; }
        .text-left { text-align: left; }
        .text-right { text-align: right; }
        .footer { display: flex; justify-content: space-between; margin-top: 24px; text-align: center; }
        .page-number {
          position: fixed;
          right: 8mm;
          bottom: 6mm;
          font-size: 11px;
        }
      </style>
    </head>
    <body>
      <div class="header-top">
        <div style="width: 60%;">
          <div><b>Đơn vị:</b> ${headerInfo.unit || ""}</div>
          <div><b>Bộ phận:</b> ${headerInfo.department || ""}</div>
        </div>
        <div style="text-align: center; width: 40%;">
          <div><b>Mẫu số: 02 - LĐTL</b></div>
          <div style="font-style: italic; font-size: 11px;">
            (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
          </div>
        </div>
      </div>

      <div class="title-box">
        <h2 class="title-main">BẢNG THANH TOÁN TIỀN THƯỞNG</h2>
        <div style="font-style: italic; margin-top: 5px;">Quý ${headerInfo.quarter} năm ${headerInfo.year}</div>
        <div style="text-align: right; margin-top: 8px;">Số: ${headerInfo.docNumber || ""}</div>
      </div>

      <table>
        <thead>
          <tr>
            <th rowspan="2">STT</th>
            <th rowspan="2">Họ và tên</th>
            <th rowspan="2">Ngạch bậc lương hoặc cấp bậc chức vụ</th>
            <th colspan="2">Mức thưởng</th>
            <th rowspan="2">Ký nhận</th>
            <th rowspan="2">Ghi chú</th>
          </tr>
          <tr>
            <th>Xếp loại thưởng</th>
            <th>Số tiền</th>
          </tr>
          <tr style="background-color: #fafafa;">
            <th>A</th>
            <th>B</th>
            <th>C</th>
            <th>1</th>
            <th>2</th>
            <th>D</th>
            <th>E</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="4" class="text-center"><b>Cộng</b></td>
            <td class="text-right"><b>${fmt(totalBonus)}</b></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 18px; font-style: italic;">
        Tổng số tiền (Viết bằng chữ): <b>${numberToWords(totalBonus)}</b>
      </div>

      <div class="footer">
        <div style="width: 25%;">
          <div><b>Người lập bảng</b></div>
          <br/>
          <i>(Ký, họ tên)</i>
        </div>
        <div style="width: 25%;">
          <div><b>Kế toán trưởng</b></div>
          <br/>
          <i>(Ký, họ tên)</i>
        </div>
        <div style="width: 30%;">
          <div style="font-style: italic; margin-bottom: 5px;">Ngày....tháng....năm....</div>
          <div><b>Giám đốc</b></div>
          <br/>
          <i>(Ký, họ tên)</i>
        </div>
      </div>

      <script>
        window.onload = function() { window.print(); };
      </script>
      <div class="page-number">1/1</div>
    </body>
  </html>
  `;
};
